import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ConfigurationService } from '../../../services/configuration.service';
import { ActualiteModel } from '../../../models/ActualiteModel';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DateService } from '../../../services/date.service';

@Component({
  selector: 'actualite-view',
  templateUrl: './actualite-view.component.html',
  styleUrls: ['./actualite-view.component.css'],
})
export class ActualiteViewComponent implements OnInit {
  saveDisabled: boolean = false;
  tinymceInit: any = {};
  editMode: boolean = true;
  keepOpen: boolean = true;
  actualite: ActualiteModel = <ActualiteModel>{};
  dateCreation: Date;
  date: Date = new Date();

  constructor(
    public configurationService: ConfigurationService,
    private dateService: DateService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.tinymceInit = {
      ...this.configurationService.tinymceBaseInit,
      plugins: ['autoresize'],
      autoresize_bottom_margin: 50,
      menubar: false,
      toolbar: false,
      statusbar: false,

      paste_data_images: true,
      automatic_uploads: true,

      images_upload_credentials: true,
      images_reuse_filename: true,
      file_picker_types: 'image',
      image_advtab: true,
    };
  }

  ngOnInit() {
    if (this.config.data.actualite) {
      this.actualite = <ActualiteModel>this.config.data.actualite;
      this.dateCreation = this.actualite.Creation != null ? this.dateService.getDateFromString(this.actualite.Creation) : this.date;
    }
  }

  cancel() {
    this.ref.close();
  }
}
